// /auth/link-expired — Figma frame 03 link-expired (33:937). Owner: screens-auth-a, US-082.
// Pre-login: deliberately no AppShell.
//
// `?reason=consumed|expired` is this screen's contract for telling "you
// waited too long" from "someone already used this link" apart — see
// `screens/signin/LinkExpiredScreen.tsx`. Defaults to "expired" so a bare
// /auth/link-expired (direct hit, no query) still renders correctly.
// screens-auth-b's /auth/callback route should navigate here with
// `search: { reason: "expired" | "consumed" }` read off the 410's `title`
// (`magic_link_expired` / `magic_link_consumed`) — see this agent's
// progress notes for the full handoff.

import { createRoute, useNavigate } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import {
  LinkExpiredScreen,
  type LinkExpiredReason,
} from "../screens/signin/LinkExpiredScreen";

type LinkExpiredSearch = { reason?: LinkExpiredReason };

export const authLinkExpiredRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/link-expired",
  validateSearch: (search: Record<string, unknown>): LinkExpiredSearch => ({
    reason: search.reason === "consumed" ? "consumed" : undefined,
  }),
  component: AuthLinkExpiredRoute,
});

function AuthLinkExpiredRoute() {
  const { reason } = authLinkExpiredRoute.useSearch();
  const navigate = useNavigate();
  return (
    <LinkExpiredScreen
      reason={reason}
      onSent={(email) =>
        navigate({ to: "/auth/link-sent", search: { email } })
      }
    />
  );
}
